import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-social-twitter-1',
  standalone: true,
  templateUrl: '../../assets/social/twitter-1.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSocialTwitter1Icon {}
